export default "__VITE_ASSET__DSmB4ZH2__"